import type { Album } from "store/album/album.model";
import type { Artist } from "store/artist/artist.model";
import type { Playlist } from "store/playlist/playlist.model";
import type { Track } from "store/track/track.model";
import {Mode} from "store/mode/mode.model";
import {Genre} from "../store/genre/genre.model";
import { toCoverUrl } from "store/baseUrls";

export const imageUrlOf = (entity: Track | Album | Playlist | Artist | Mode | Genre, from: 'sm' | 'md' = 'sm') => {
  if("coverId" in entity) {
    return toCoverUrl(entity.coverId);
  }
  if("coverLinkId" in entity) {
    return toCoverUrl(entity.coverLinkId);
  }
  if (entity.posterId) {
    return toCoverUrl(entity.posterId);
  }
  if ("imageSm" in entity && entity?.['imageSm']?.length && from === 'sm') {
    return entity?.['imageSm'];
  }
  if ("imageMd" in entity &&  entity?.['imageMd']?.length && (from === 'sm' || from === 'md')) {
    return entity?.['imageMd'];
  }
  if ("imageLg" in entity && entity?.['imageLg']?.length) {
    return entity?.['imageLg'];
  }
  if (entity.coverLink) {
    return entity.coverLink;
  }
  if ((entity as Playlist).playlistCoverId) {
    return toCoverUrl((entity as Playlist).playlistCoverId);
  }
  return toCoverUrl(null);
};
